import styled from 'styled-components/macro';
import { colors as Colors } from 'constants/colors';
//import { media } from 'style/media';
//import PropTypes from 'prop-types';

export const ServiceBlockContainer = styled.div.attrs(props => ({
  background: props.background ? props.background : Colors.TRANSPARENT,
}))`
  display: flex;
  flex-direction: column;
  background: ${props => props.background};
`;

//ServiceBlockContainer.propTypes = {
//  column: PropTypes.bool
//};
